import { SalesOrderComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1310. 受注案件コメント一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
}
const salesOrderComments = (props: Props): Promise<SalesOrderComment[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}/sales_order_comments`);
};
export const useSalesOrderComments = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => salesOrderComments(props)
  });
};

export const useSalesOrderCommentsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'sales_orders', props.id, 'sales_order_comments'];
};
